import { useSelector } from 'react-redux';

import { getIsReOpsUser } from 'entities/User';
import { getUserCanSeeSpendInsights } from 'entities/User/model/selectors/userPermissionsSeletors';
import { useReportVisible } from 'shared/lib/hooks/useReportVisible';

export const useSpendSummaryReportVisible = (): boolean | undefined => {
    const canSee = useSelector(getUserCanSeeSpendInsights);
    const isReOpsUser = useSelector(getIsReOpsUser);

    return useReportVisible({
        flagKey: 'report_spend_summary_enabled',
        canSee,
        isReOpsUser,
    });
};
